import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';

const BATS = [
  { top: '14%', delay: '0s', dur: '19s', size: 26 },
  { top: '32%', delay: '6s', dur: '24s', size: 18 },
  { top: '58%', delay: '11s', dur: '21s', size: 22 },
  { top: '76%', delay: '3s', dur: '27s', size: 14 },
];

const Bat = ({ size }) => (
  <svg width={size} height={size * 0.5} viewBox="0 0 64 32" fill="currentColor" aria-hidden="true">
    <path d="M32 10c2-4 4-6 6-6-1 2-1 4 0 5 4-4 12-6 26-3-6 2-10 6-11 12-3-3-7-3-10 0-2-2-5-2-7 1-1-3-2-4-4-4s-3 1-4 4c-2-3-5-3-7-1-3-3-7-3-10 0C10 12 6 8 0 6c14-3 22-1 26 3 1-1 1-3 0-5 2 0 4 2 6 6z" />
  </svg>
);

const Web = ({ className }) => (
  <svg className={className} width="180" height="180" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="0.5" aria-hidden="true">
    {[0, 22.5, 45, 67.5, 90].map((a) => (
      <line key={a} x1="0" y1="0" x2={100 * Math.cos((a * Math.PI) / 180)} y2={100 * Math.sin((a * Math.PI) / 180)} />
    ))}
    {[20, 38, 56, 74, 92].map((r) => (
      <path key={r} d={`M${r} 0 Q ${r * 0.82} ${r * 0.34} ${r * 0.92} ${r * 0.38} T ${r * 0.71} ${r * 0.71} T ${r * 0.38} ${r * 0.92} T 0 ${r}`} />
    ))}
  </svg>
);

// Applies a temporary site theme while a themed sale is live, and reverts the moment it ends.
export default function SeasonalTheme() {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    let timer;
    api.get('/sale/current').then(({ data }) => {
      if (!data?.active || !data.theme) return;
      const msLeft = new Date(data.ends_at).getTime() - Date.now();
      if (msLeft <= 0) return;
      setTheme(data.theme);
      timer = setTimeout(() => setTheme(null), Math.min(msLeft, 2_147_000_000));
    }).catch(() => {});
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!theme) return undefined;
    const cls = `theme-${theme}`;
    document.documentElement.classList.add(cls);
    return () => document.documentElement.classList.remove(cls);
  }, [theme]);

  if (theme !== 'halloween') return null;
  return (
    <div className="halloween-layer" data-testid="halloween-decor" aria-hidden="true">
      <div className="halloween-fog" />
      <div className="halloween-fog halloween-fog--2" />
      <Web className="halloween-web halloween-web--left" />
      <Web className="halloween-web halloween-web--right" />
      {BATS.map((b, i) => (
        <div key={i} className="halloween-bat" style={{ top: b.top, animationDelay: b.delay, animationDuration: b.dur }}>
          <Bat size={b.size} />
        </div>
      ))}
    </div>
  );
}
